import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ShoppingPage } from './shopping.page';
import { FoodPage } from './food/food.page';
import { RetailPage } from './retail/retail.page';

const routes: Routes = [
  {
    path: 'shopping',
    component: ShoppingPage,
    children: [
      // {
      //   path: 'food',
      //   children: [
      //     {
      //       path: '',
      //       component: FoodPage,
      //     },
      //   ],
      // },
      {
        path: 'retail',
        children: [
          {
            path: '',
            component: RetailPage,
          },
        ],
      },
      {
        path: '',
        redirectTo: '/shopping/food',
        pathMatch: 'full',
      },
    ],
  },
  { 
    path: 'terms-and-condition', 
    loadChildren: './terms-condition/terms-condition.module#TermsConditionPageModule' 
  },
  {
    path: '',
    redirectTo: '/shopping/retail',
    pathMatch: 'full',
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShoppingRoutingModule { }
